import PageLayout from '@/pages/layout/PageLayout'
import UserInfo from '@/pages/user/UserInfo'
import UserList from '@/pages/user/UserList'
import UserCreate from '@/pages/user/UserCreate'
import UserContainer from '@/pages/user/UserContainer'
import CheckAuth from '@/pages/components/AuthCheck'
import { AUTH_GROUP } from '../../constants/constants'

const children = [{
  path: '/user/info',
  name: 'UserInfo',
  component: CheckAuth(UserContainer(UserInfo), [
    AUTH_GROUP.BespinAdmin,
    AUTH_GROUP.BespinManager,
    AUTH_GROUP.BespinMiddleManager,
    AUTH_GROUP.AccountManager,
    AUTH_GROUP.BespinBilling,
  ],
    '/user/list'
  )
}, {
  path: '/user/list',
  name: 'UserList',
  component: UserContainer(UserList)
}, {
  path: '/user/create',
  name: 'UserCreate',
  component: CheckAuth(UserContainer(UserCreate), [AUTH_GROUP.BespinAdmin], '/user/list')
}]

export default [{
  path: '/',
  component: PageLayout,
  children
}]



// WEBPACK FOOTER //
// ./src/router/children/user.js